import { styled, css } from "styled-components";
import { UnstyledButton, spacing } from "@wayflyer/flyui";

import type { InteractiveBadgeProps } from "./interactive-badge";

export const StyledBadge = styled(UnstyledButton)<{
  $status: InteractiveBadgeProps["status"];
}>`
  height: 22px;
  font-size: var(--typography-fontSize-sm);
  font-weight: var(--typography-fontWeight-regular);
  display: inline-flex;
  align-items: center;
  color: ${({ $status, theme }) =>
    $status && theme.palette.content.status[$status]
      ? theme.palette.content.status[$status]
      : theme.palette.content.neutral.strong};
  gap: var(--sizes-spacing-1);

  &:focus-visible {
    outline: 1px dotted;
  }

  ${({ theme, $status }) => {
    return css`
      border-radius: var(--sizes-spacing-2);
      padding: ${spacing(["1", "3"])};
      background: ${$status ? String(theme.palette.bg.status[$status]) : theme.palette.bg.status.neutral};
    `;
  }}
`;
